// Row contracts of Founder OS (FOUNDER-OS; 12): the founder brief. Same conventions as `rows.ts`:
// keys are column names, nullability is the column's, enums are the CHECK's;
// `contract-drift.test.ts` binds it to its table. The control-plane rows (`account_company`,
// `linked_seat`, `goal_link`) are served only through the portfolio views (api/portfolio.ts).
import { z } from "zod";
import { FounderBriefCadence, FounderBriefSource } from "./enums";
import { Timestamp, Uuid } from "./primitives";

export const FounderBriefLine = z
  .object({
    text: z.string(),
    company_id: Uuid.nullable(),
    tone: z.enum(["good", "bad", "neutral"]),
    /** The projection kind a company line was written from (FOUNDER-OS: filtered at read time). */
    kind: z
      .enum(["kpi", "goals", "finance", "escalation", "decisions", "meetings", "headcount"])
      .optional(),
  })
  .meta({ id: "FounderBriefLine" });

export const FounderBriefSection = z
  .object({ key: z.string(), title: z.string(), lines: z.array(FounderBriefLine) })
  .meta({ id: "FounderBriefSection" });
export type FounderBriefSection = z.infer<typeof FounderBriefSection>;

export const FounderBrief = z
  .object({
    company_id: Uuid,
    id: Uuid,
    cadence: FounderBriefCadence,
    period_key: z.string(),
    generated_by: FounderBriefSource,
    headline: z.string(),
    sections: z.array(FounderBriefSection),
    created_at: Timestamp,
  })
  .meta({ id: "FounderBrief" });
export type FounderBrief = z.infer<typeof FounderBrief>;
